import { ISiteUsersTableReport } from "../../Interfaces/siteUserInterfaces";
import { CommonTableUI } from "../TableTemplate/common";
import { ITableUI } from "../TableTemplate/tableTemplate";
import { SiteUserTableContext } from "./SiteUserTable";
import { SiteUsersTableAdditional } from "./SiteUsersTableAdditional";
import { useContext, useEffect } from "react";

export const SiteUsersTableUI: React.FC<ITableUI<ISiteUsersTableReport>> = ({
  reports,
  onAction,
}: ITableUI<ISiteUsersTableReport>) => {
  const { setTableRefreshFlag, tableRefreshFlag } =
    useContext(SiteUserTableContext);

  useEffect(() => {
    if (tableRefreshFlag && onAction) {
      onAction();
      setTableRefreshFlag(false);
    }
  }, [tableRefreshFlag]);

  return (
    <CommonTableUI
      reports={reports}
      onAction={onAction}
      AdditionalBody={SiteUsersTableAdditional}
      tableBoxClassName="max-h-[calc(100dvh-230px)] overflow-y-auto"
    />
  );
};
